export class GoToDocumentsTabEvent {}
